import { AirbrakeNotifier } from 'Components/Airbrake';

export const notifyDatadogAndAirbrake = (
  errorMessage: string,
  contextComponent: string,
  data: any
) => {
  AirbrakeNotifier.notify({
    error: errorMessage,
    context: {
      component: contextComponent,
      data,
    },
  });
  (window as any).DD_RUM.addAction('html_received', {
    body: data,
  });
};
